import styles from 'styles/pages/common/Terms.module.scss';
import { ReactComponent as ChevronRightIcon } from 'assets/icons/chevron_right.svg';
import { STYLES_VARIABLES } from 'constants/styleVariables';
import { Link, useNavigate } from 'react-router-dom';
import SingleBtn from 'components/common/elements/SingleBtn';
import { ROUTE_PATH } from 'constants/routePath';
import LoginLayout from 'components/common/layout/LoginLayout';
import { FormProvider, useForm, useWatch } from 'react-hook-form';
import FormCheckbox from 'components/common/forms/FormCheckbox';
import { useMutation } from 'react-query';
import { TTermsForm, TermsField, TermsFormField } from 'types/form/auth';
import { putTermsOfUseAgree } from 'apis/auth';
import { TermsFormDefaultValues } from 'constants/auth';

const Terms = () => {
  const title = '서비스 이용을 위해\n하단의 약관에 동의해 주세요.';

  const navigate = useNavigate();

  const methods = useForm<TTermsForm>({
    defaultValues: TermsFormDefaultValues,
  });
  const { handleSubmit, control, setValue } = methods;

  const termsCheckAllValue = useWatch({
    control,
    name: TermsField.TermsAgree,
  });

  const { mutate: putTermsOfUseAgreeMutation } = useMutation(
    'putTermsOfUseAgree',
    putTermsOfUseAgree,
    {
      onSuccess: () => {
        navigate(ROUTE_PATH.common.MYPAGE_EDIT);
      },
    }
  );

  const handleTermsCheckAllChange = (checked: string) => {
    const termsArr = checked.split(',');
    const includesAll =
      termsArr.includes(TermsFormField.PrivatePolicy) &&
      termsArr.includes(TermsFormField.TermsOfUse);

    if (includesAll) {
      setValue(TermsField.TermsAgree, []);
    } else {
      setValue(TermsField.TermsAgree, [
        TermsFormField.PrivatePolicy,
        TermsFormField.TermsOfUse,
      ]);
    }
  };

  const onValid = async () => {
    if (termsCheckAllValue?.length === 2) {
      putTermsOfUseAgreeMutation();
    }
  };

  return (
    <LoginLayout title={title}>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onValid)}>
          <div className={styles.checkbox_wrapper}>
            <FormCheckbox
              id={TermsFormField.TermsCheckAll}
              text="모두 동의합니다."
              name={TermsField.TermsAgree}
              labelStyle={{
                fontWeight: 700,
              }}
              multiple={true}
              value={TermsFormField.TermsCheckAll}
              checked={termsCheckAllValue?.length === 2}
              afterChange={(checked) =>
                handleTermsCheckAllChange(checked.toString())
              }
            />
            <div className="divider_line mt16 mb24"></div>
            <div className={styles.link_wrapper}>
              <div className="flex justify_between items_center">
                <FormCheckbox
                  id={TermsFormField.PrivatePolicy}
                  text="[필수] 개인정보 위탁처리 동의서"
                  name={TermsField.TermsAgree}
                  value={TermsFormField.PrivatePolicy}
                  multiple={true}
                />
                <Link to={ROUTE_PATH.common.PRIVACY_POLICY}>
                  <ChevronRightIcon fill={STYLES_VARIABLES.GRAY_06} />
                </Link>
              </div>
              <div className="flex justify_between items_center">
                <FormCheckbox
                  id={TermsFormField.TermsOfUse}
                  text="[필수] 서비스 이용약관"
                  name={TermsField.TermsAgree}
                  value={TermsFormField.TermsOfUse}
                  multiple={true}
                />
                <Link to={ROUTE_PATH.common.TERMS_OF_USE}>
                  <ChevronRightIcon fill={STYLES_VARIABLES.GRAY_06} />
                </Link>
              </div>
            </div>
            <SingleBtn
              type="submit"
              btnText="동의"
              isBtnActive={termsCheckAllValue?.length === 2}
              btnStyle={{ width: '100%' }}
              disabled={termsCheckAllValue?.length !== 2}
            />
          </div>
        </form>
      </FormProvider>
    </LoginLayout>
  );
};

export default Terms;
